window.lib = window.lib || {};
window.images = window.images || {};
window.ss = window.ss || {};
(function (lib, img, ss, cjs) {

var p; // shortcut to reference prototypes

lib.ssMetadata = [];


(lib.AnMovieClip = function(){
	this.actionFrames = [];
	this.ignorePause = false;
	this.gotoAndPlay = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndPlay.call(this,positionOrLabel);
	}
	this.play = function(){
		cjs.MovieClip.prototype.play.call(this);
	}
	this.gotoAndStop = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndStop.call(this,positionOrLabel);
	}
	this.stop = function(){
		cjs.MovieClip.prototype.stop.call(this);
	}
}).prototype = p = new cjs.MovieClip();
// symbols:



(lib.Background_Blue = function() {
	this.initialize(img.SplashAssets_Background_Blue);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,977,2052);


(lib.LongerMainButtonDis = function() {
	this.initialize(img.SplashAssets_LongerMainButtonDis);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,518,126);


(lib.LongerMainButtonDown = function() {
	this.initialize(img.SplashAssets_LongerMainButtonDown);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,518,126);


(lib.LongerMainButtonHi = function() {
	this.initialize(img.SplashAssets_LongerMainButtonHi);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,518,126);


(lib.LongerMainButtonUp = function() {
	this.initialize(img.SplashAssets_LongerMainButtonUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,518,126);


(lib.ProfessorRod = function() {
	this.initialize(img.SplashAssets_ProfessorRod);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,2277,2084);


(lib.SplashBGPanel = function() {
	this.initialize(img.SplashAssets_SplashBGPanel);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1002,739);


(lib.Splashscreen = function() {
	this.initialize(img.SplashAssets_Splashscreen);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,2667,6188);


(lib.WhiteArrow = function() {
	this.initialize(img.SplashAssets_WhiteArrow);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,73,61);// helper functions:

function mc_symbol_clone() {
	var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop, this.reversed));
	clone.gotoAndStop(this.currentFrame);
	clone.paused = this.paused;
	clone.framerate = this.framerate;
	return clone;
}

function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
	var prototype = cjs.extend(symbol, cjs.MovieClip);
	prototype.clone = mc_symbol_clone;
	prototype.nominalBounds = nominalBounds;
	prototype.frameBounds = frameBounds;
	return prototype;
	}


(lib.LoadingBarFront = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#0F97FF").s().p("AgJAeQgNAAgJgJQgIgIAAgNQAAgLAIgKQAJgIANAAIATAAQAMAAAJAIQAJAKAAALQAAANgJAIQgJAJgMAAg");
	this.shape.setTransform(4,3);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.LoadingBarFront, new cjs.Rectangle(0,0,8,6), null);


(lib.Background = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Background_Blue();
	this.instance.setTransform(-667,-1286,1.3655,1.3655);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Background, new cjs.Rectangle(-667,-1286,1334.1,2802), null);


(lib.LoadingBarBar = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer 2
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#0F97FF").s().p("ApjAeIAAg7ITHAAIAAA7g");
	this.shape.setTransform(61.2,3);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.LoadingBarBar, new cjs.Rectangle(0,0,122.4,6), null);


(lib.StartGameButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {up:0,over:1,down:2,disabled:3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// arrow
	this.instance = new lib.WhiteArrow();
	this.instance.setTransform(197,-31);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(4));

	// Text Down
	this.downLabelTextField = new cjs.Text("Starten", "45px 'Poppins SemiBold'", "#FFFFFF");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.textAlign = "center";
	this.downLabelTextField.lineHeight = 43;
	this.downLabelTextField.lineWidth = 363;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(10.6,-38);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// Text Up
	this.upLabelTextField = new cjs.Text("Starten", "45px 'Poppins SemiBold'", "#FFFFFF");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.textAlign = "center";
	this.upLabelTextField.lineHeight = 43;
	this.upLabelTextField.lineWidth = 363;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(10.6,-38);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// Text Over
	this.overLabelTextField = new cjs.Text("Starten", "45px 'Poppins SemiBold'", "#FFFFFF");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.textAlign = "center";
	this.overLabelTextField.lineHeight = 43;
	this.overLabelTextField.lineWidth = 363;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(10.6,-38);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// Text Disabled
	this.disabledLabelTextField = new cjs.Text("Starten", "45px 'Poppins SemiBold'", "#FFFFFF");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.textAlign = "center";
	this.disabledLabelTextField.lineHeight = 43;
	this.disabledLabelTextField.lineWidth = 363;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(10.6,-38);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// Button
	this.instance_1 = new lib.LongerMainButtonUp();
	this.instance_1.setTransform(-210,-63);

	this.instance_2 = new lib.LongerMainButtonHi();
	this.instance_2.setTransform(-210,-63);

	this.instance_3 = new lib.LongerMainButtonDown();
	this.instance_3.setTransform(-210,-63);

	this.instance_4 = new lib.LongerMainButtonDis();
	this.instance_4.setTransform(-210,-63);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1}]}).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_3}]},1).to({state:[{t:this.instance_4}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-210,-63,518,127);


(lib.splashTextPanel = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// startbutton
	this.startbutton = new lib.StartGameButton();
	this.startbutton.name = "startbutton";
	this.startbutton.setTransform(266.45,626.3,1,1,0,0,0,0.1,0.1);

	this.timeline.addTween(cjs.Tween.get(this.startbutton).wait(1));

	// bodyTextField
	this.bodyTextfield = new cjs.Text("In this game you help a team develop newiiii", "40px 'Poppins'", "#0F5184");
	this.bodyTextfield.name = "bodyTextfield";
	this.bodyTextfield.lineHeight = 56;
	this.bodyTextfield.lineWidth = 894;
	this.bodyTextfield.parent = this;
	this.bodyTextfield.setTransform(68.35,460.6473,0.9999,0.9999);
ranj.TextOffsetFixer.fix(this.bodyTextfield);

	this.timeline.addTween(cjs.Tween.get(this.bodyTextfield).wait(1));

	// titleTextField
	this.titleTextfield = new cjs.Text("Fishing game", "bold 144px 'Poppins ExtraBold'", "#0F5184");
	this.titleTextfield.name = "titleTextfield";
	this.titleTextfield.lineHeight = 154;
	this.titleTextfield.lineWidth = 882;
	this.titleTextfield.parent = this;
	this.titleTextfield.setTransform(68.35,51.45);
ranj.TextOffsetFixer.fix(this.titleTextfield);

	this.timeline.addTween(cjs.Tween.get(this.titleTextfield).wait(1));

	// panelBG
	this.instance = new lib.SplashBGPanel();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.splashTextPanel, new cjs.Rectangle(0,0,1002,739), null);


(lib.LoadingBar = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_99 = function() {
		/* stop();*/
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).wait(99).call(this.frame_99).wait(1));

	// Layer_3 copy
	this.instance = new lib.LoadingBarFront();
	this.instance.setTransform(6,5,1,1,0,0,0,4,3);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({x:287},99).wait(1));

	// LoadingBarBar
	this.instance_1 = new lib.LoadingBarBar();
	this.instance_1.setTransform(6,2,0.0082,1);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).to({scaleX:2.2875},99).wait(1));

	// Layer_3
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#0F97FF").s().p("AgJAeQgNAAgJgJQgIgIAAgNQAAgLAIgKQAJgIANAAIATAAQAMAAAJAIQAJAKAAALQAAANgJAIQgJAJgMAAg");
	this.shape.setTransform(6,5);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(100));

	// Layer_2
	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#FFFFFF").s().p("A2GAyQgUAAgPgPQgPgOAAgVQAAgUAPgOQAPgPAUAAMAsNAAAQAUAAAPAPQAPAOAAAUQAAAVgPAOQgPAPgUAAg");
	this.shape_1.setTransform(146.5,5);

	this.timeline.addTween(cjs.Tween.get(this.shape_1).wait(100));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,293,10);


(lib.SplashLoadScreenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// loadingTextField
	this.loadingTextField = new cjs.Text("loading", "13px 'Poppins Medium'", "#FFFFFF");
	this.loadingTextField.name = "loadingTextField";
	this.loadingTextField.textAlign = "center";
	this.loadingTextField.lineHeight = 23;
	this.loadingTextField.lineWidth = 289;
	this.loadingTextField.parent = this;
	this.loadingTextField.setTransform(0,746.05,2.7273,2.7273);
ranj.TextOffsetFixer.fix(this.loadingTextField);

	this.timeline.addTween(cjs.Tween.get(this.loadingTextField).wait(1));

	// loadingBar
	this.loadingBar = new lib.LoadingBar();
	this.loadingBar.name = "loadingBar";
	this.loadingBar.setTransform(-403,688,2.7273,2.7273);

	this.timeline.addTween(cjs.Tween.get(this.loadingBar).wait(1));

	// Professor
	this.instance = new lib.ProfessorRod();
	this.instance.setTransform(-280,262,0.2846,0.2854);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// textPanel
	this.textPanel = new lib.splashTextPanel();
	this.textPanel.name = "textPanel";
	this.textPanel.setTransform(-2,-470.5,1,1,0,0,0,501,369.5);

	this.timeline.addTween(cjs.Tween.get(this.textPanel).wait(1));

	// bg
	this.instance_1 = new lib.Splashscreen();
	this.instance_1.setTransform(766.5,-1032,0.5,0.5,0,0,180);

	this.bg = new lib.Background();
	this.bg.name = "bg";

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.bg},{t:this.instance_1}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.SplashLoadScreenSkin, new cjs.Rectangle(-667.5,-1286,1746.9,3348), null);


// stage content:
(lib.SplashAssets = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer 1
	this.instance = new lib.SplashLoadScreenSkin();
	this.instance.setTransform(538.8,872,1,1,0,0,0,-1.2,1);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = p = new lib.AnMovieClip();
p.nominalBounds = new cjs.Rectangle(-181.1,456,1487.6,2477);
// library properties:
lib.properties = {
	id: '2D758ABF18A3194E856740076AC96F36',
	width: 1080,
	height: 1742,
	fps: 24,
	color: "#0F97FF",
	opacity: 1.00,
	manifest: [
		{src:"assets/skins/images/SplashAssets/Background_Blue.png", id:"SplashAssets_Background_Blue", bundle:"SplashAssets"},
		{src:"assets/skins/images/SplashAssets/LongerMainButtonDis.png", id:"SplashAssets_LongerMainButtonDis", bundle:"SplashAssets"},
		{src:"assets/skins/images/SplashAssets/LongerMainButtonDown.png", id:"SplashAssets_LongerMainButtonDown", bundle:"SplashAssets"},
		{src:"assets/skins/images/SplashAssets/LongerMainButtonHi.png", id:"SplashAssets_LongerMainButtonHi", bundle:"SplashAssets"},
		{src:"assets/skins/images/SplashAssets/LongerMainButtonUp.png", id:"SplashAssets_LongerMainButtonUp", bundle:"SplashAssets"},
		{src:"assets/skins/images/SplashAssets/ProfessorRod.png", id:"SplashAssets_ProfessorRod", bundle:"SplashAssets"},
		{src:"assets/skins/images/SplashAssets/SplashBGPanel.png", id:"SplashAssets_SplashBGPanel", bundle:"SplashAssets"},
		{src:"assets/skins/images/SplashAssets/Splashscreen.png", id:"SplashAssets_Splashscreen", bundle:"SplashAssets"},
		{src:"assets/skins/images/SplashAssets/WhiteArrow.png", id:"SplashAssets_WhiteArrow", bundle:"SplashAssets"}
	],
	preloads: []
};



})(lib.SplashAssets = {}, images, ss, createjs);
module.exports = lib.SplashAssets;